/* eslint-disable solid/reactivity */
import { Expand } from '@magicdoor/ui';
import { splitProps } from 'solid-js';
import { cn } from '~/utils/classnames';
import type { ComponentProps, JSX } from 'solid-js';

type ExpandableSectionProps = {
  btnClass?: string;
  triggerTitle: JSX.Element;
  children: JSX.Element;
  headerBorder?: boolean;
  onExpand?: (isOpen: boolean) => void;
  action?: JSX.Element;
  ref?: any;
  noncollapsible?: JSX.Element;
};

const ExpandableSection = (props: ExpandableSectionProps & ComponentProps<typeof Expand>) => {
  const [expandProps, localProps] = splitProps(props, ['open', 'onOpenChange', 'defaultOpen']);
  return (
    <Expand {...expandProps} class={cn('flex w-full flex-col items-stretch px-4 text-sm text-text-level01', localProps.class)}>
      <Expand.Trigger as="div" class="flex w-full justify-between">
        <button
          type="button"
          class={cn(
            'flex w-full justify-between py-3 text-left font-medium leading-5 md:py-4',
            localProps.headerBorder && 'mb-4 border-b border-partingline',
            localProps.btnClass
          )}>
          {localProps.triggerTitle}
        </button>
        <div
          class="flex items-center gap-1"
          classList={{
            'border-b border-partingline mb-4': localProps.headerBorder,
          }}>
          <div>{localProps.noncollapsible}</div>
          <div class="flex cursor-pointer items-center gap-3 px-3">
            <div class="rounded hover-allowed:hover:bg-input-border">{localProps?.action}</div>
            <Expand.Indicator />
          </div>
        </div>
      </Expand.Trigger>
      <Expand.Content>{localProps.children}</Expand.Content>
    </Expand>
  );
};

export default ExpandableSection;
